import script from "./FlashbackPage.vue?vue&type=script&setup=true&lang=js"
export * from "./FlashbackPage.vue?vue&type=script&setup=true&lang=js"

import "./FlashbackPage.vue?vue&type=style&index=0&id=2b67eaee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b67eaee"]])

export default __exports__